export default function CashbackIcon() {
    return (
        <svg>
            <use xlinkHref="#cashbackLabel" />
        </svg>
    );
}
